import { Link } from 'expo-router'
import { useState, type PropsWithChildren, type ReactNode } from 'react'
import { useIntl } from 'react-intl'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Message } from '@/src/elements/message'
import { Typography } from '@/src/elements/text/Typography'
import { getDeviceInfos } from '@/src/general/utils/getDeviceInfos'
import { useTranslate } from '@/src/lang/useTranslate'

const listPrefix = '• '

const getSupportLink = (browser: string, locale: string) => {
  if (browser === 'chrome' || browser === 'chromium') {
    return `https://support.google.com/chrome/answer/114662?visit_id=637224508551579227-3732219886&rd=1&hl=${locale}`
  }
  if (browser === 'firefox') {
    return {
      fr: 'https://support.mozilla.org/fr/kb/notifications-web-push-firefox',
      en: 'https://support.mozilla.org/en-US/kb/push-notifications-firefox',
      es: 'https://support.mozilla.org/es/kb/notificaciones-push-en-firefox',
      pt: 'https://support.mozilla.org/pt-BR/kb/notificacoes-web-push-firefox',
    }[locale]
  }
  return undefined
}

const EnablePushLink = (): ReactNode => {
  const { t } = useTranslate()
  const { locale } = useIntl()

  const browser = getDeviceInfos().browser.name?.toLowerCase() || ''
  const supportLink = getSupportLink(browser, locale)

  return (
    supportLink && (
      <Link href={supportLink} className="text-blue-500 hover:text-blue-700">
        <Typography>{t('push.blocked.support-link', { browser })}</Typography>
      </Link>
    )
  )
}
const ListItem = ({ children }: PropsWithChildren): ReactNode => (
  <Typography>
    {listPrefix}
    {children}
  </Typography>
)

export const ReactivatePush = (): ReactNode => {
  const [canDisplayInstructions, setCanDisplayInstructions] = useState(false)
  const { t } = useTranslate()

  return (
    <View className="pt-4">
      {canDisplayInstructions ? (
        <Message onClose={() => setCanDisplayInstructions(false)}>
          <Typography>{t('push.blocked.how-to.url-icon.browser')}</Typography>
          <View className="py-2 pl-2">
            <ListItem>{t('push.blocked.how-to.url-icon.click')}</ListItem>
            <ListItem>{t('push.blocked.how-to.url-icon.allow')}</ListItem>
          </View>
          <Typography>{t('push.blocked.how-to.settings.icon')}</Typography>
          <View className="py-2 pl-2">
            <ListItem>{t('push.blocked.how-to.settings.find-list')}</ListItem>
            <ListItem>{t('push.blocked.how-to.settings.find-hozana')}</ListItem>
            <ListItem>{t('push.blocked.how-to.settings.allow')}</ListItem>
          </View>
          <EnablePushLink />
        </Message>
      ) : (
        <Button colors="secondary" variant="solid" onPress={() => setCanDisplayInstructions(true)}>
          {t('push.blocked.how-to.reactivate')}
        </Button>
      )}
    </View>
  )
}
